import styled from '@emotion/styled'
import { FormControlLabel } from '@mui/material'

export const OptionItem = styled(FormControlLabel)(() => {
  return {
    boxShadow: '0px 0px 4px rgba(0,0,0,.2)',
    borderRadius: '10px',
    justifyContent: 'center',
    padding: '1rem',
    margin: '0px',
    marginBottom: '1rem',
    '& .MuiRadio-root': {
      display: 'none',
    },
    // ...props.sx
  }
})
